import { TableChangeState } from 'react-bootstrap-table-next';
import { ITableScroll, TSetTableFiltersAction, TSetTableScrollAction } from '../../types/redux/tables';

export const SET_TABLE_FILTERS = 'SET_TABLE_FILTERS';
export const SET_TABLE_SCROLL = 'SET_TABLE_SCROLL';

export const setTableFilters = (tableName: string, payload: TableChangeState<any>['filters']): TSetTableFiltersAction => ({
    type: SET_TABLE_FILTERS,
    payload,
    tableName,
});

export const setTableScroll = (tableName: string, payload: ITableScroll): TSetTableScrollAction => ({
    type: SET_TABLE_SCROLL,
    payload,
    tableName,
});
